var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.29006 2.12002L5.17006 6.00002L1.29006 9.88002C0.900059 10.27 0.900059 10.9 1.29006 11.29C1.68006 11.68 2.31006 11.68 2.70006 11.29L7.29006 6.70002C7.68006 6.31002 7.68006 5.68002 7.29006 5.29002L2.70006 0.70002C2.31006 0.310019 1.68006 0.310019 1.29006 0.70002C0.910058 1.09002 0.900058 1.73002 1.29006 2.12002Z"}));
}

ChevronRight.defaultProps = {"width":"8","height":"12","viewBox":"0 0 8 12","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
